import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { OrdemInsumoTransferencia } from '../../../types/OrdemInsumoTransferencia.type';
import { OrdemInsumoTransferenciaItem } from '../../../types/OrdemInsumoTransferenciaItem.type';
import { Remessa } from '../../../types/Remessa.type';

@Component({
  selector: 'app-atendimento-dialog',
  templateUrl: './atendimento-dialog.component.html',
  styleUrl: './atendimento-dialog.component.css',
  providers: [ConfirmationService],
})
export class AtendimentoDialogComponent {
  @Input() visivel: boolean = false;
  @Input() remessa!: Remessa;
  @Output() public fechar = new EventEmitter();

  atendimentoEnviado: boolean = false;
  transferencias: { [s: string]: OrdemInsumoTransferenciaItem } = {};

  constructor(
    private painelService: PainelinsumoService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  onShow() {
    if (this.remessa) {
      this.remessa.itens.forEach((item) => {
        let itemTransf: OrdemInsumoTransferenciaItem = {
          insumo: item.cdMaterialPims,
          quantidade: 0,
        };

        this.transferencias[item.cdMaterialPims] = itemTransf;
      });
    }
  }

  escondeDialog() {
    this.visivel = false;
    this.remessa = {} as Remessa;
    this.atendimentoEnviado = false;

    this.fechar.emit();
  }

  confirmarAtendimento(event: Event) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Tem certeza que deseja realizar o atendimento?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon:"none",
      rejectIcon:"none",
      rejectButtonStyleClass:"p-button-text",
      acceptLabel: "Atender",
      rejectLabel: "Cancelar",
      accept: () => {
        this.enviar();
      },
    });
    
  }

  enviar() {
    this.atendimentoEnviado = true;
    let transfers: OrdemInsumoTransferencia = {} as OrdemInsumoTransferencia;

    transfers.os = this.remessa.id;
    transfers.usuario = localStorage.getItem("cdUsuarioErp") || ""

    transfers.itens = [];

    for (const [key, value] of Object.entries(this.transferencias)) {
      let transf = value as OrdemInsumoTransferenciaItem;

      if (transf.quantidade > 0) {
        let item: OrdemInsumoTransferenciaItem =
          {} as OrdemInsumoTransferenciaItem;

        item.insumo = transf.insumo;
        item.quantidade = transf.quantidade;

        transfers.itens.push(item);
      }
    }

    if (transfers.itens.length <= 0) {
      this.toastService.info(
        '',
        'Digite a quantidade para realizar a operação'
      );
    } else {
      this.painelService.postAtender(transfers).subscribe({
        next: (data) => {
          this.toastService.sucesso(
            'Sucesso',
            'Atendimento realizada com sucesso'
          );
          this.escondeDialog();
        },
        error: (error) => {
          console.error(error);
          this.toastService.erro('Erro', error.error.message);
        },
      });
    }
  }
}
